import React, { useEffect } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { AnimatePresence } from "framer-motion";

import { auth } from "./firebase";
import { setUser, clearUser } from "./store/Auth/userActions";

// Components
import Message from "./Components/Message";
import Header from "./Components/Header";

// Pages
import Login from "./Pages/Auth/Login";
import Register from "./Pages/Auth/Register";
import Home from "./Pages/Home";
import ProductDetail from "./Pages/Detail";
import Checkout from "./Pages/Checkout";
import Orders from "./Pages/Orders";
import Examer from "./Pages/Examer";
import Iot from "./Pages/Iot";
import Examination from "./Pages/Examination";
import Banner from "./Pages/Banner";
import Procuremention from "./Pages/Procurement/Procuremention";
import Procurement from "./Pages/Procurement/Procurement";

const RouterApp = (props) => {
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) props.setUser(user);
      else props.clearUser();
    });
    return () => unsubscribe();
  }, [props]);

  return (
    <>
      <Message />
      <Header />

      {/* AnimatePresence untuk transisi antar halaman */}
      <AnimatePresence exitBeforeEnter>
        <Switch>

          {/* Auth routes */}
          <Route exact path="/register" component={Register} />
          <Route exact path="/login" component={Login} />

          {/* Checkout & Orders */}
          <Route exact path="/checkout" component={Checkout} />
          <Route exact path="/orders/:phone" component={Orders} />

          {/* Examination */}
          <Route exact path="/tryout" component={Examer} />
          <Route exact path="/examer/:id" component={Examination} />

          {/* Produk dan banner */}
          <Route exact path="/product/:p1" component={ProductDetail} />
          <Route exact path="/banner" component={Banner} />

          {/* Procurement */}
          <Route exact path="/Procurement" component={Procurement} />
          <Route exact path="/Procuremention/:id" component={Procuremention} />

           {/* Iot */}
          {/* <Route exact path="/iot" component={Iot} /> */}
          <Route exact path="/iot" component={Iot} />
          <Route exact path="/iot/:datetime/:locate" component={Iot} />
          
          {/* Home — harus paling terakhir */}
          <Route path="/:p1?/:p2?" component={Home} />
        </Switch>
      </AnimatePresence>
    </>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.user.isLoading,
});

const mapDispatchToProps = { setUser, clearUser };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RouterApp));
